var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewspaperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.72,
    height: 24.72,
    viewBox: "0 0 24.72 24.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "newspaper-outline",
    transform: "translate(-2.475 -2.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M21.005,23.642V4.7a1.326,1.326,0,0,0-1.323-1.323H4.7A1.326,1.326,0,0,0,3.375,4.7V24.091a2.21,2.21,0,0,0,2.2,2.2H23.65",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M28.52,27.512h0a2.645,2.645,0,0,1-2.645-2.645V9h3.967a1.323,1.323,0,0,1,1.323,1.323V24.868a2.645,2.645,0,0,1-2.645,2.645Z",
    transform: "translate(-4.87 -1.217)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M16.875,9H20.4",
    transform: "translate(-2.922 -1.217)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M16.875,13.5H20.4",
    transform: "translate(-2.922 -2.191)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M7.875,18H18.453",
    transform: "translate(-0.974 -3.165)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M7.875,22.5H18.453",
    transform: "translate(-0.974 -4.139)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M7.875,27H18.453",
    transform: "translate(-0.974 -5.113)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M11.158,13.164H7.632a.882.882,0,0,1-.882-.882V8.757a.882.882,0,0,1,.882-.882h3.526a.882.882,0,0,1,.882.882v3.526A.882.882,0,0,1,11.158,13.164Z",
    transform: "translate(-0.73 -0.974)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperIcon);
export default __webpack_public_path__ + "static/media/newspaper-icon.ebacc102cb90b6f30fb0eb3ba2f8425e.svg";
export { ForwardRef as ReactComponent };